var _rect, _rect2, _path, _path2, _path3, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#F7FBF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 21,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#C7E3C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 24C11 23.7239 11.2239 23.5 11.5 23.5H23V24.5H11.5C11.2239 24.5 11 24.2761 11 24Z",
    fill: "#C7E3C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 24C11 24.2761 11.2239 24.5 11.5 24.5H17H18V16.5H23V15.5H17.5C17.2239 15.5 17 15.7239 17 16V23.5H11.5C11.2239 23.5 11 23.7239 11 24Z",
    fill: "#43A047"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 19C23.4477 19 23 18.5523 23 18V14C23 13.4477 23.4477 13 24 13H28C28.5523 13 29 13.4477 29 14V18C29 18.5523 28.5523 19 28 19H24ZM25.5 17.5C25.5 17.7761 25.7239 18 26 18C26.2761 18 26.5 17.7761 26.5 17.5V16.5H27.5C27.7761 16.5 28 16.2761 28 16C28 15.7239 27.7761 15.5 27.5 15.5H26.5V14.5C26.5 14.2239 26.2761 14 26 14C25.7239 14 25.5 14.2239 25.5 14.5V15.5H24.5C24.2239 15.5 24 15.7239 24 16C24 16.2761 24.2239 16.5 24.5 16.5H25.5V17.5Z",
    fill: "#43A047"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#E6EAEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTop);
export default __webpack_public_path__ + "static/media/AddTop.81a683fda47a62e6f31d5d40f293105e.svg";
export { ForwardRef as ReactComponent };